import React from "react";
import PropTypes from "prop-types";

import styles from "./Claimant.module.css";
import SampleWatermark from "../SampleWatermark";

let options = { year: "numeric", month: "numeric", day: "numeric" };
const formatDate = (x, options) =>{
  var dateParts = x.split("T")[0].split("-");
  return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]).toLocaleDateString("en-us", options);
}
const formatValue = x => {
  if (x.type === "Date") {
    return formatDate(x.value, options);
  }
  return x.value;
};
const Claimant = ({ claimantData, salesTaxData, isDual, className, isDummyVin }) => {
  if (isDual) {
    claimantData = claimantData.map(field =>
      field.key === "cClaimType" ? { ...field, value: "Dual Fees" } : field
    );
  }
  let salesTaxElements = [];
  const taxBreakdown = false;
  if(taxBreakdown && salesTaxData !== null){
    salesTaxElements.push({key: 0, label: "Tax Breakdown", value: ""});
    Object.keys(salesTaxData).forEach((key, index) => {
      if(salesTaxData[key] > 0 && ["stateTax", "cityTax", "countyTax", "totalTax"].indexOf(key) >= 0 ){
        var label = ""
        switch(key){
          case "stateTax":
            label = "State Tax"
            break;
          case "cityTax":
            label = "City Tax"
            break;
          case "countyTax":
            label = "County Tax"
            break;
          case "totalTax":
            label = "Total Tax"
            break;
          default:
            label = ""
            break;
        }
        salesTaxElements.push({key: index + 1, label: label, value: salesTaxData[key]});
      }
    });
  }
    return (
    <section className={`${styles.base} ${className}`} data-claimant>
      <header className={styles.header}>
        <h3 className={styles.widgetTitle} id="Claimant_id">Claimant</h3>
      </header>
      <ul className={styles.list} data-claimant-fields>
      {claimantData.map(x => {
          const renderListItem = (label, value) => (
            <li key={x.key} className={styles.item}>
              <span id={label} className={styles.label}>{label}:</span>
              <span id={`${label} Value`} className={styles.value}>{value}</span>
            </li>
          );

          if (isDummyVin === "yes" && x.key === "cVin") {
            return renderListItem(x.label, "No VIN Entered");
          }

          const valueContent = isDummyVin !== "yes"
            ? <span dangerouslySetInnerHTML={{ __html: formatValue(x) }}></span>
            : <span dangerouslySetInnerHTML={{ __html: formatValue(x) }}></span>;

          return renderListItem(x.label, valueContent);
          
        })}
        {salesTaxElements.map(x => (
          x.key === 0 ?
            <li key={x.key} className={styles.item} style={{marginTop: '15px'}}>
              <span className={styles.label}> {x.label}</span>
              <span className={styles.value}></span>
            </li>
            :
            <li key={x.key} className={styles.item}>
            <span className={styles.label}> {x.label}:</span>
            <span className={styles.value}>{(x.value * 100).toFixed(2)}%</span>
          </li>
        ))}
      </ul>
      <SampleWatermark />
    </section>
  );
};

Claimant.propTypes = {
  claimantData: PropTypes.array,
  className: PropTypes.string
};

Claimant.defaultProps = {
  claimantData: [],
  className: ""
};

export default Claimant;
